export function CheckIcon() {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
      <path
        d="M0.833008 4.64229L3.8336 8.12297L9.53471 1.50968"
        stroke="currentColor"
        strokeWidth="1.25"
      />
    </svg>
  );
}
